import type { RootState } from 'state';

function getRouteFromSelectedFilters(state: RootState): string {
  const { airportsFrom, airportsTo } = state.flightCalendars.filtersValues;
  return `${airportsFrom.join('')}${airportsTo.join('')}`;
}

export default getRouteFromSelectedFilters;
